export function getMetaData(metaName: string): string[] {
  if (typeof document === "undefined") {
    throw new Error("getMetaData must be called on the client side");
  }

  const metaTags = document.querySelectorAll<HTMLMetaElement>(
    `meta[name="${metaName}"]`
  );
  const contents: string[] = [];

  metaTags.forEach((tag) => {
    if (tag.content) {
      contents.push(tag.content);
    }
  });

  return contents.sort((a, b) => a.localeCompare(b));
}
